import { Link } from "react-router-dom";
import type { Guide } from "@/types";

export default function GuideCard({ guide }: { guide: Guide }) {
  return (
    <article className="group flex flex-col gap-4 rounded-xl border border-background-200 bg-background-50 p-4 transition-all hover:shadow-lift hover:border-background-300 sm:flex-row md:p-5">
      <Link
        to={`/zhinan/${guide.id}`}
        className="block h-40 w-full shrink-0 overflow-hidden rounded-lg sm:h-auto sm:w-44 md:w-52 cursor-pointer"
      >
        <img
          src={guide.cover}
          alt={guide.title}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </Link>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex items-center gap-2">
          <span className="rounded-md bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-800">
            {guide.catName}
          </span>
          <span className="inline-flex items-center gap-1 text-xs text-foreground-400">
            <i className="ri-time-line" />
            阅读 {guide.readTime}
          </span>
        </div>
        <h3 className="mt-2 font-display text-base font-bold leading-snug text-foreground-950 md:text-lg">
          <Link to={`/zhinan/${guide.id}`} className="transition-colors hover:text-primary-700 cursor-pointer">
            {guide.title}
          </Link>
        </h3>
        <p className="mt-0.5 text-sm font-medium text-primary-600">{guide.subtitle}</p>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{guide.excerpt}</p>
        <div className="mt-auto flex items-center justify-between pt-3">
          <div className="flex flex-wrap gap-1.5">
            {guide.tags.slice(0, 2).map((t) => (
              <span key={t} className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                #{t}
              </span>
            ))}
          </div>
          <Link
            to={`/zhinan/${guide.id}`}
            className="inline-flex whitespace-nowrap items-center gap-1 text-sm font-semibold text-accent-700 hover:text-accent-800 cursor-pointer"
          >
            读全文
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </article>
  );
}